export class Organization {
  name: string;
  url: URL;
  avatar?: string;
  id: string;
  ssoIsMandatory: boolean;
  identityProviderName: string;

  constructor({
    name,
    url,
    avatar,
    id: organizationId,
    ssoIsMandatory,
    identityProviderName
  }: OrganizationData) {
    this.name = name;
    this.url = url;
    this.avatar = avatar;
    this.id = organizationId;
    this.ssoIsMandatory = ssoIsMandatory;
    this.identityProviderName = identityProviderName;
  }
}

/**
 * True when the user reaches `organization` through more than one identity
 * provider, so its rows only differ by that provider's name.
 */
export function showsIdentityProvider(organization: Organization, organizations: Organization[]): boolean {
  if (!organization.identityProviderName) {
    return false;
  }
  const sameOrganization = organizations.filter(other => other.id == organization.id);
  return sameOrganization.length > 1;
}

export interface OrganizationData {
  name: string;
  url: URL;
  avatar?: string;
  id: string;
  ssoIsMandatory: boolean;
  identityProviderName: string;
}
